import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [branchId, setBranchId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const api = process.env.REACT_APP_API_URL || (["localhost", "127.0.0.1"].includes(window.location.hostname) ? "/api" : "/api");
    let active=true,latest=0;
    const refresh=()=>{const ticket=++latest;fetch(`${api}/admin/me`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if(!active||ticket!==latest)return;
        if (data.status === "success") {
          setUser(data.admin);
          setPermissions(data.permissions || []);
          setBranchId(data.branch_id || null);
        } else {
          setUser(null);
          setPermissions([]);
        }
      })
      .catch(() => {if(active&&ticket===latest){setUser(null);setPermissions([]);}})
      .finally(() => {if(active&&ticket===latest)setLoading(false);});
    };
    refresh();
    const focus=()=>{if(!document.hidden)refresh();};
    const timer=setInterval(focus,30000);
    window.addEventListener('focus',focus);
    return()=>{active=false;clearInterval(timer);window.removeEventListener('focus',focus);};
  }, []);

  return (
    <AuthContext.Provider value={{ user, permissions, branchId, loading,
      accessibleBranches: user?.accessible_branches || [],
      canSwitchBranch: user?.role === "staff" && (user?.accessible_branches || []).length > 1 }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export {AuthContext};
